<div class="mdc-layout-grid__inner price-page">
	<div
		class="mdc-layout-grid__cell--span-12-phone mdc-layout-grid__cell--span-7-desktop mdc-layout-grid__cell--span-8-tablet"
		[ngClass]="{ 'mobile-background': viewport.type !== 'desktop', 'phone-screen': viewport.type === 'desktop' }"
	>
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<div class="ad">
					<div class="cover">
						<img *ngIf="viewport.type !== 'mobile'" [src]="'/assets/images/vip/viewpackage-banner.svg' | s3Image" />

						<img *ngIf="viewport.type === 'mobile'" [src]="'/assets/images/vip/banner-phone.svg' | s3Image" />
					</div>
				</div>
			</div>

			<div class="mdc-layout-grid__cell--span-12 pricingPage" [ngClass]="{ 'other-language': locale.lang == 'ar' || locale.lang == 'ku' }">
				<h4>{{ locale.translations['vip']['n449'] }}</h4>

				<p class="pink pt-2">{{ locale.translations['vip']['n456'] }}</p>

				<span *ngIf="locale.lang == 'en'">
					<ul class="list" [ngClass]="{ 'mobile-list': viewport.type !== 'desktop', 'desktop-li': viewport.type === 'desktop' }">
						<li>
							<span>{{ locale.translations['vip']['n457'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n458'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n459'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n460'] }}</span>
						</li>
					</ul>
				</span>

				<span *ngIf="locale.lang == 'ar' || locale.lang == 'ku'">
					<ul class="listAr" [ngClass]="{ 'mobile-list': viewport.type !== 'desktop', 'desktop-li': viewport.type === 'desktop' }">
						<li>
							<span>{{ locale.translations['vip']['n457'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n458'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n459'] }}</span>
						</li>

						<li>
							<span>{{ locale.translations['vip']['n460'] }}</span>
						</li>
					</ul>
				</span>

				<div class="mdc-layout-grid__cell--span-12" *ngIf="viewport.type !== 'desktop'">
					<div class="mdc-layout-grid__cell--span-6 adViewSection">
						<span *ngIf="locale.lang == 'en'">
							<p class="adViewText">{{ locale.translations['vip']['n461'] }}</p>
						</span>

						<span *ngIf="locale.lang == 'ku' || locale.lang == 'ar'">
							<p class="adViewText-other">{{ locale.translations['vip']['n461'] }}</p>
						</span>

						<img [src]="adView" class="img-responsive mobile-image" />

						<span *ngIf="locale.lang == 'en'">
							<h6 class="adPrice" *ngIf="getPrice() === 1">{{ locale.translations['payment']['n223'] }}</h6>

							<h6 class="adPrice" *ngIf="getPrice() === 0">{{ locale.translations['payment']['n222'] }}</h6>
						</span>

						<span *ngIf="locale.lang == 'ku'">
							<h6 class="adPriceAr" *ngIf="getPrice() === 1">{{ locale.translations['payment']['n223'] }}</h6>

							<h6 class="adPriceAr" *ngIf="getPrice() === 0">{{ locale.translations['payment']['n222'] }}</h6>
						</span>

						<span *ngIf="locale.lang == 'ar'">
							<h6 class="adPriceAr" *ngIf="getPrice() === 1">{{ locale.translations['payment']['n223'] }}</h6>

							<h6 class="adPriceAr" *ngIf="getPrice() === 0">{{ locale.translations['payment']['n222'] }}</h6>
						</span>
					</div>
				</div>
			</div>

			<div class="mdc-layout-grid__cell--span-12 boostBtnSection" *ngIf="viewport.type !== 'desktop'">
				<a
					class="boostNowBtn"
					mat-flat-button
					color="accent"
					[routerLink]="['/payment']"
					[queryParams]="{ package: 'vip', adID: queryAdID, Cat: category }"
					[disabled]="category === '0'"
				>
					<mat-icon class="mat-icon-rtl-mirror">trending_up</mat-icon>

					<span>&nbsp;{{ locale.translations['vip']['n462'] }}</span>
				</a>
			</div>
		</div>
	</div>
	<div
		class="mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-12-phone package-details"
		*ngIf="viewport.type === 'desktop'"
	>
		<div class="mdc-layout-grid__inner d-flex justify-content-between">
			<div class="mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-desktop">
				<h5>{{ locale.translations['payment']['n464'] }}</h5>
			</div>

			<div class="mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-desktop">
				<h5 *ngIf="getPrice() === 1">{{ locale.translations['payment']['n223'] }}</h5>

				<h5 *ngIf="getPrice() === 0">{{ locale.translations['payment']['n222'] }}</h5>
			</div>
		</div>

		<mat-divider></mat-divider>

		<div class="mdc-layout-grid__inner d-flex justify-content-between">
			<div class="mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-desktop">
				<h4>{{ locale.translations['payment']['n465'] }}</h4>
			</div>

			<div class="mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-desktop">
				<h4 *ngIf="getPrice() === 1">{{ locale.translations['payment']['n223'] }}</h4>

				<h4 *ngIf="getPrice() === 0">{{ locale.translations['payment']['n222'] }}</h4>
			</div>
		</div>

		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12 boost">
				<button
					mat-flat-button
					type="button"
					color="accent"
					[routerLink]="['/payment']"
					[queryParams]="{ package: 'vip', adID: queryAdID, Cat: category }"
					class="boost-now"
					[disabled]="category === '0'"
				>
					<mat-icon class="mat-icon-rtl-mirror">trending_up</mat-icon>

					<span>&nbsp;{{ locale.translations['vip']['n462'] }}</span>
				</button>
			</div>
		</div>
	</div>
</div>
